import { NumberField as FoundationNumberField, defaultNumberFieldConfig as foundationNumberFieldConfig, foundationNumberFieldShadowOptions, foundationNumberFieldTemplate as foundationNumberFieldTemplate, } from '@genesislcap/foundation-ui';
import { zeroNumberFieldStyles as styles } from './number-field.styles';
/**
 * @tagname %%prefix%%-number-field
 */
export class NumberField extends FoundationNumberField {
}
export const defaultNumberFieldConfig = foundationNumberFieldConfig;
export const zeroNumberFieldTemplate = foundationNumberFieldTemplate;
export const zeroNumberFieldShadowOptions = foundationNumberFieldShadowOptions;
export const zeroNumberField = NumberField.compose(Object.assign({ baseName: 'number-field', template: zeroNumberFieldTemplate, styles, shadowOptions: zeroNumberFieldShadowOptions }, defaultNumberFieldConfig));
